import { memo, useState } from 'react';
import { Box, Divider, Flex, Text, Tooltip, useMediaQuery } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// import SettingIconComponent from 'components/Icons/SettingIcon';
import LogoV2 from 'components/Icons/LogoV2';
import LogoutModal from 'components/LogoutModal';
import AuthModalContainer from 'components/AuthModal/AuthModalContainer';
import { getUserData } from 'redux/UserSlice';

import ModelSettingsModal from './ModelSettingsModal';

interface LogoSectionProperties {
  modelName?: string;
  modelData?: any;
}

const LogoSection = memo(({ modelName, modelData }: LogoSectionProperties) => {
  const [isTablet] = useMediaQuery('(max-width: 1024px)');
  const navigate = useNavigate();
  const displayName = modelName || 'Model Name';
  // TypeScript workaround for complex union type from useMediaQuery
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isTabletSize = Boolean(isTablet as any);
  const user = useSelector(getUserData);
  const [modalState, setModalState] = useState({
    logoutModal: false,
    authModal: false,
    modelSettingsModal: false,
  });
  const [isLogoTriggered, setIsLogoTriggered] = useState(false);

  const toggleLogoutModal = () => {
    setModalState((previousState) => ({
      ...previousState,
      logoutModal: !previousState.logoutModal,
    }));
  };

  const toggleAuthModal = () => {
    setModalState((previousState) => ({
      ...previousState,
      logoutModal: false,
      authModal: !previousState.authModal,
    }));
  };
  // @ts-ignore - Known TypeScript limitation with Chakra UI useMediaQuery complex union types
  const onLogoClick = () => {
    if (user?.is_anonymous) {
      toggleLogoutModal();
      setIsLogoTriggered(true);
    } else {
      navigate('/home');
    }
  };
  // const handleSettingIconClick = () => {
  //   setModalState((previousState) => ({
  //     ...previousState,
  //     modelSettingsModal: true,
  //   }));
  // };

  const toggleModelSettingsModal = () => {
    setModalState((previousState) => ({
      ...previousState,
      modelSettingsModal: !previousState.modelSettingsModal,
    }));
  };
  return (
    <>
      <Flex alignItems='center' gap={4} flexShrink={0}>
        <Box flexShrink={0}>
          <LogoV2 onClick={onLogoClick} styles={{ cursor: 'pointer' }} />
        </Box>
        <Divider orientation='vertical' h='40px' flexShrink={0} />
        {/* @ts-ignore - TypeScript limitation with conditional Chakra UI props */}
        <Flex
          alignItems='center'
          bg='white'
          border='1px solid #D9D9D9'
          borderRadius='12px'
          p='8px 12px'
          gap={2}
          minW={0}
          flex={isTabletSize ? 1 : undefined}
          maxW={isTabletSize ? '250px' : undefined}
        >
          <Box minW={0} flex={1}>
            {isTabletSize ? (
              <Tooltip label={displayName} hasArrow placement='bottom-start'>
                <Text
                  fontSize='sm'
                  fontWeight='semibold'
                  color='gray.800'
                  isTruncated
                  display='block'
                >
                  {displayName}
                </Text>
              </Tooltip>
            ) : (
              <Text fontSize='sm' fontWeight='semibold' color='gray.800'>
                {displayName}
              </Text>
            )}
          </Box>
          {/* <Divider orientation='vertical' h='20px' flexShrink={0} color='#C1C1C1' />
          <Box
            cursor='pointer'
            onClick={handleSettingIconClick}
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            <SettingIconComponent color='black.900' />
          </Box> */}
        </Flex>
      </Flex>
      <LogoutModal
        isOpen={modalState.logoutModal}
        onClose={toggleLogoutModal}
        onOpenAuthModal={toggleAuthModal}
        isLogoTriggered={isLogoTriggered}
        setIsLogoTriggered={setIsLogoTriggered}
      />
      <AuthModalContainer
        isOpen={modalState.authModal}
        onClose={toggleAuthModal}
        setIsLogoTriggered={setIsLogoTriggered}
      />
      <ModelSettingsModal
        isOpen={modalState.modelSettingsModal}
        onClose={toggleModelSettingsModal}
        modelData={modelData}
      />
    </>
  );
});

LogoSection.displayName = 'LogoSection';

export default LogoSection;
